import { render, staticRenderFns } from "./SafetyManagerManageDiv.vue?vue&type=template&id=0bab7202&scoped=true&"
import script from "./SafetyManagerManageDiv.vue?vue&type=script&lang=js&"
export * from "./SafetyManagerManageDiv.vue?vue&type=script&lang=js&"
import style0 from "./SafetyManagerManageDiv.vue?vue&type=style&index=0&id=0bab7202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab7202",
  null
  
)

export default component.exports